// components/CustomNumberInput.jsx
import React from "react";
import { styled } from "@mui/system";
import { palette } from "../../themes/theme"; // Adjust path if needed

const InputWrapper = styled("div")({
  display: "inline-flex",
  alignItems: "center",
  border: "1px solid black",
  borderRadius: 4,
  backgroundColor: "white",
  width: 80,
  overflow: "hidden",
  "&:focus-within": {
    borderColor: palette.primary.main,
  },
});

const StyledInput = styled("input")({
  border: "none",
  outline: "none",
  background: "transparent",
  width: "100%",
  textAlign: "center",
  color: "#333",
  fontSize: 14,
  padding: "6px 4px",
  "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button": {
    display: "none",
  },
  MozAppearance: "textfield",
});

const ButtonGroup = styled("div")({
  display: "flex",
  flexDirection: "column",
  borderLeft: "1px solid #ccc",
});

const ArrowButton = styled("button")({
  all: "unset",
  width: 20,
  height: 20,
  fontSize: 12,
  lineHeight: 1,
  textAlign: "center",
  cursor: "pointer",
  userSelect: "none",
  backgroundColor: "#eee",
  color: "#333",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  "&:hover": {
    backgroundColor: "#ccc",
  },
});

export default function CustomNumberInput({
  value,
  onChange,
  min = 0,
  max = 100,
  step = 1,
}) {
  const handleChange = (e) => {
    console.log(e, "hc");
    let val = parseInt(e.target.value, 10);
    if (isNaN(val)) val = min;
    if (val > max) val = max;
    if (val < min) val = min;
    onChange(val);
  };

  const increment = () => {
    let newVal = Math.min(value + step, max);
    onChange(newVal);
  };

  const decrement = () => {
    let newVal = Math.max(value - step, min);
    onChange(newVal);
  };

  return (
    <InputWrapper>
      <StyledInput
        type="number"
        value={value}
        onChange={handleChange}
        min={min}
        max={max}
      />
      <ButtonGroup>
        <ArrowButton onClick={increment}>▲</ArrowButton>
        <ArrowButton onClick={decrement}>▼</ArrowButton>
      </ButtonGroup>
    </InputWrapper>
  );
}
